import { withTranslation } from "react-i18next";
import { connect } from 'react-redux'
import TourLineTicket from './TourLineTicket';

import * as tourActions from '../../../../../../../../../actions/tourAction';
import * as tourTicketActions from '../../../../../../../../../actions/tourTicketAction';

const mapStateToProps = state => {
    return {
        tourTicket: state.tourTicketReducer,
        tourState: state.tourReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        createItemTicketDetail: (itemTicket) => dispatch(tourActions.createItemTicketDetail(itemTicket)),
        updateItemTicketDetail: (itemTicket) => dispatch(tourActions.updateItemTicketDetail(itemTicket)),
        deleteItemTicketDetail: (itemTicket) => dispatch(tourActions.deleteItemTicketDetail(itemTicket)),
        getAllTicketsById: (id) => dispatch(tourTicketActions.getAllTicketsById(id)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(TourLineTicket));
